import React, { useState } from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import { generatePath } from 'react-router-dom'
import FormNewsletterSettings from '../../forms/FormNewsletterSettings'
import Translation from '../../Translation/cont/Translation'
import requestStatus from '../../../constants/requestStatus'
import OverlaySpinner from '../../overlay/presentational/OverlaySpinner'
import OverlayText from '../../overlay/presentational/OverlayText'

const PageNewsletterCampaignSettings = ({
    itemData, 
    themeData, 
    translationStrings,
    currentLang,
    translationDebug,
    goBackPath, 
    match, 
    sendStatus,
    sendError,
    onSwitchToPreview,
    onResetSettings,
    onUpdateSettings
}) => {   
    const closePagePath = generatePath(goBackPath, match.params)

    const [settingsOverlay, setSettingsOverlay] = useState(false)


    let overlay = ''

    if (requestStatus.REQUEST_PENDING === sendStatus ) {
        overlay = <OverlaySpinner transId="print_newsletter_settings_are_saved" />
    } else if(requestStatus.REQUEST_ERROR === sendStatus) {
        overlay = <OverlayText
            titleTransId="print_newsletter_an_error_has_occurred"
            text={sendError ? sendError.message : ''}
            buttonTextTransId='data_load_againg'
            onClickButton={() => onResetSettings(true)}
        />
    } else if(settingsOverlay) {
        overlay = settingsOverlay
    } else if(requestStatus.REQUEST_SUCCESS === sendStatus) {
        overlay = ''
    }

    return (
        <WrapperPageSimple
            pageTitleTransId='newsletter_settings_page'
            closePagePath={closePagePath} 
            overlay={overlay}
        >
            <div className="program-page site-content">
                {itemData ? (
                    <FormNewsletterSettings
                        itemData={itemData}
                        themeData={themeData}
                        translationStrings={translationStrings}
                        currentLang={currentLang}
                        translationDebug={translationDebug}
                        setSettingsOverlay={setSettingsOverlay}
                        onSwitchToPreview={onSwitchToPreview}
                        onResetSettings={onResetSettings}
                        onUpdateSettings={onUpdateSettings}
                    />
                ):(
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default PageNewsletterCampaignSettings